import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';
import '../src/component/navbar.css';

import Home from './component/Home';
import Navbar from './component/Navbar';
import About from './component/About';
import Gallery from './component/Gallery';
import Appointment from './component/Appointment';



function App() {
  return (
    <div className='main' >
      <Router>
        
        <Navbar/>
        <Routes>

          <Route path="*" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Appointment" element={<Appointment />} />
         
        </Routes>
      </Router>
    </div>
  );
}

export default App;
